import styled from 'styled-components';

export const Heading = styled.div`
  font-size: ${({ level }) => 4 / (level ?? 1)}rem;
  font-weight: bold;
  margin: 0;
`;
